import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";
import ReportTasksTimeChart_Settings from "./settings";

export default class ReportTasksTimeChart extends Report<ReportTasksTimeChart_Settings> {

    public static reportName         : string = "Time-based Chart"

    declare settings     : ReportTasksTimeChart_Settings // redefine any


    constructor(data: ReportConfig) {
        data.type           = ViewType.REPORT_TASKS_TIME_CHART
        super(data);

        this.icon           = "isvg-chart-line"
        this.description    = "Visualizes how values change over time (e.g. daily, weekly, monthly). Ideal for tracking trends, activity, or performance over a timeline."

        this.settings       = new ReportTasksTimeChart_Settings(data.settings)

    }

    static initFromSavedView(savedView: SavedView): ReportTasksTimeChart {
        return new ReportTasksTimeChart(savedView.toReportConfig());
    }

    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTasksTimeChart_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectIds = [projectId]
    }

    save(){
        console.log("Not implemented")
    }
}
